import { NgModule } from '@angular/core';
import { NotificationThrottlingComponent } from './notification-throttling.component';
import { CommonModule } from '@angular/common';
import { RelaySharedModule } from '@app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
@NgModule({
    imports: [
        CommonModule,
        RelaySharedModule,
        FormsModule,
        InfiniteScrollDirective,
        NotificationThrottlingComponent,
    ],
    exports: [NotificationThrottlingComponent],
})
export class NotificationThrottlingModule {}
